import {AvailableOption, PromotionByProductCustomer} from "@/models";
import {IDescription} from "@/interface";

export class INewOrder {
    id: number;
    product: string;
    optionsData: AvailableOption[];
    optionsOther: AvailableOption[];
    guid: string;
    name: string;
    descriptions: IDescription;
    technical_descriptions: IDescription;
    pricing: { price: number; billable: boolean };
    for_residential: boolean;
    for_professional: boolean;
    promo: PromotionByProductCustomer

    constructor(base?: Partial<INewOrder>) {
        if (base) {
            Object.assign(this, base);
        }
    }
}